const firstTab = document.querySelector('.js-product-tab-height');
const firstTabHeight = firstTab.clientHeight;

if (firstTabHeight > 608) {
  firstTab.closest('.product-tabs').style.minHeight = `${firstTabHeight}px`;
}

// loop through all triggers
const productTabTrigger = document.querySelectorAll('.js-product-tabs-collapsible-header');
productTabTrigger.forEach( trigger => {

    trigger.addEventListener('click', (e) => {

      function obCallback(entry) {
  
        // check if tab content is visible
        if (entry[0].isIntersecting) {

          // get height
          let tabHeight = entry[0].target.firstElementChild.clientHeight;

          // set min height on tabs container
          if (tabHeight > 608) {
            entry[0].target.closest('.product-tabs').style.minHeight = `${tabHeight}px`;  
          } else {
            entry[0].target.closest('.product-tabs').style.minHeight = '';  
          }
        }
      }
 
      const ob = new IntersectionObserver(obCallback);
      const watch = e.target.parentElement.nextElementSibling;

      if (watch !== null ) {
        ob.observe(watch);
      }
    
  });

});




